import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Navbar from 'shared/components/Navbar';
import { HIDDEN_NAVBAR_PREFIXES, appRoutes } from 'app/routes';

import './app.css';

function App() {
  const navbarRef = useRef(null);
  const [navbarHeight, setNavbarHeight] = useState(0);
  const location = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useLayoutEffect(() => {
    const root = document.documentElement;
    const previousScrollBehavior = root.style.scrollBehavior;
    let frameId;
    let timeoutId;

    const resetScroll = () => {
      root.style.scrollBehavior = 'auto';
      window.scrollTo({ top: 0, left: 0 });
      document.body.scrollTop = 0;
      root.scrollTop = 0;
      root.style.scrollBehavior = previousScrollBehavior;
    };

    resetScroll();
    frameId = window.requestAnimationFrame(resetScroll);
    timeoutId = window.setTimeout(resetScroll, 120);

    return () => {
      window.cancelAnimationFrame(frameId);
      window.clearTimeout(timeoutId);
      root.style.scrollBehavior = previousScrollBehavior;
    };
  }, [location.pathname]);

  useEffect(() => {
    if (navbarRef.current) {
      setNavbarHeight(navbarRef.current.offsetHeight);
    }
  }, []);

  const hideNavbar = HIDDEN_NAVBAR_PREFIXES.some((prefix) =>
    location.pathname.startsWith(prefix)
  );

  return (
    <div className="App">
      {!hideNavbar && (
        <div ref={navbarRef}>
          <Navbar />
        </div>
      )}
      <div className="chat-bubble">{/* ChatBubble intentionally disabled. */}</div>
      <Routes>
        {appRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={route.render({ navbarHeight })}
          />
        ))}
      </Routes>
    </div>
  );
}

export default function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}
